<label class="field-label"><%= I18n.patient.labels.email %></label>
<input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="email" name="email" required value="<%- email %>" placeholder="<%= I18n.patient.placeholders.email %>">
